<div class="flex h-full min-h-0 flex-row justify-start gap-2.5">
  <div
    class="text-primary flex h-full min-h-0 w-[20vw] flex-col items-center justify-start gap-2.5 overflow-visible"
    [style.color]="accentColor | contentBuilderColor"
  >
    @if (displayArrows) {
      <div
        class="flex h-[3.5vh] w-full cursor-pointer items-center justify-center rounded-t-lg shadow-sm"
        [style.backgroundColor]="backgroundColor | contentBuilderColor"
        (pointerdown)="startScroll('up')"
        (pointerup)="stopScroll()"
        (pointerleave)="stopScroll()"
        #scrollUpIcon
      >
        <i class="icon icon-chevron-down rotate-180"></i>
      </div>
    }

    <div
      #scrollContainer
      class="text-primary flex min-h-0 w-full flex-1 flex-col overflow-y-auto scrollbar-hide"
      [style.justify-content]="categoryCardsJustifyContent"
      [style.--selection-overflow]="selectionOverflowInline"
      [style.width]="'calc(100% + 2 * var(--selection-overflow))'"
      [style.margin-inline]="'calc(-1 * var(--selection-overflow))'"
      [style.padding-inline]="'var(--selection-overflow)'"
      [style.padding-block]="'var(--selection-overflow)'"
      [style.gap]="categoryCardGapCss"
      [@staggeredListAnimation]="{
        value: displayItems.length,
        params: { animateEnterElementFromTopToBottom: true },
      }"
    >
      @for (item of displayItems; track item; let i = $index) {
        <div
          class="relative flex w-full flex-col items-center text-center transition-transform duration-150"
          (click)="categoryClick(item, i)"
          [attr.aria-label]="item.label"
          [style.border-radius]="categoryCardBorderRadiusCss"
          [style.box-shadow]="selectedCategoryBoxShadow(isCategorySelected(i))"
          [style.transform]="selectedCategoryZoomTransform(isCategorySelected(i))"
          [style.z-index]="isCategorySelected(i) && displaySelectedCategoryZoom ? 1 : null"
        >
          <div
            class="relative flex w-full flex-col overflow-hidden"
            [style.border-radius]="categoryCardBorderRadiusCss"
            [class.pt-4]="categoryCardPadding && displayCategoryName"
            [style.backgroundColor]="
              isCategorySelected(i)
                ? (itemSelectedBackgroundColor | contentBuilderColor)
                : (itemBackgroundColor | contentBuilderColor)
            "
            [style.border-width]="
              displaySelectedCategoryBorder ? selectedCategoryBorderWidthCss : '0'
            "
            [style.border-style]="displaySelectedCategoryBorder ? 'solid' : null"
            [style.border-color]="selectedCategoryBorderColorCss(isCategorySelected(i))"
          >
            <div
              class="bg-gray w-full bg-center bg-no-repeat"
              [class.bg-contain]="categoryCardPadding"
              [class.bg-cover]="!categoryCardPadding"
              [style.aspect-ratio]="categoryImageAspectRatio"
              [ngStyle]="{
                'background-image': item.icon ? 'url(' + categoryImageUrl(item.icon) + ')' : '',
              }"
            ></div>
            @if (displayCategoryName) {
              <p
                class="kiosk-xl:px-6 px-2 py-3 text-base font-bold"
                [style.color]="
                  (isCategorySelected(i)
                    ? itemSelectedTextColor || accentColor
                    : itemTextColor || accentColor
                  ) | contentBuilderColor
                "
              >
                {{ item.label }}
              </p>
            }
          </div>
        </div>
      }
    </div>

    @if (displayArrows) {
      <div
        class="flex h-[3.5vh] w-full cursor-pointer items-center justify-center rounded-b-lg"
        [style.backgroundColor]="backgroundColor | contentBuilderColor"
        (pointerdown)="startScroll('down')"
        (pointerup)="stopScroll()"
        (pointerleave)="stopScroll()"
        #scrollDownIcon
      >
        <i class="icon icon-chevron-down"></i>
      </div>
    }
  </div>
  @if (displayDots) {
    <div
      class="flex h-full flex-col items-center justify-center gap-2.5"
      [style.opacity]="isScrollIndicatorVisible() ? '1' : '0'"
      [style.transition]="isScrollIndicatorVisible() ? 'opacity 0ms' : 'opacity 500ms ease-out'"
    >
      @for (item of displayItems; track item; let i = $index) {
        <div
          class="h-2.5 w-2.5 rounded-full transition-all"
          [ngStyle]="{
            'background-color':
              i !== activeIndex
                ? (backgroundColor | contentBuilderColor)
                : (accentColor | contentBuilderColor),
          }"
        ></div>
      }
    </div>
  }
</div>
